<section *ngIf="visible" class="balance-charity-care-section" data-balance-charity-care-section>
  <mmx-expandable-card [title]="'balance.charity-care.title'" [loading]="loading">
    <mmx-charity-care-summary
      [patientCharityCareStatus]="status ?? undefined"
      [timezone]="timezone ?? undefined"
      [patientId]="patientId ?? undefined">
    </mmx-charity-care-summary>
  </mmx-expandable-card>
</section>
